import React, { useEffect, useReducer } from 'react';
import JsonView from '@uiw/react-json-view';

// REDUX
import { useAppSelector } from '@Managers/Redux/Hooks';
import { getAuthenticateData, getUserActionResponseData } from '@Managers/Redux/HttpState';

// STYLES
import styles from './HttpResponse.scss';

function HttpResponse() {
    const [state, setState] = useReducer((state: {}, newState: { jsonView: boolean; data?: any }) => ({ ...state, ...newState }), {
        jsonView: false,
        data: {}
    });
    const actionData = useAppSelector(getUserActionResponseData);
    const authData = useAppSelector(getAuthenticateData);

    useEffect(() => {
        if (authData && Object.keys(authData).length > 0 && authData.gameId) {
            setState({ jsonView: true, data: authData });
        }
    }, [authData]);

    useEffect(() => {
        if (actionData && Object.keys(actionData).length > 0 && actionData.cycleId) {
            setState({ jsonView: true, data: actionData });
        }
    }, [actionData]);

    return <div className={styles.json_view}>{state.jsonView && <JsonView collapsed={2} value={state.data} />}</div>;
}

export default HttpResponse;
